import {
  DEFAULT_CHATBOT_NODE_COLOR,
  DEFAULT_INTERFACE_NODE_COLOR,
  DEFAULT_NODE_COLOR,
  DEFAULT_TABLE_NODE_COLOR,
  DEFAULT_ZAP_NODE_COLOR,
} from "@zapier/canvas-constants";
import { AssetType } from "@zapier/canvas-state";

const DEFAULT_COLORS_BY_ASSET_TYPE = {
  table: DEFAULT_TABLE_NODE_COLOR,
  interface: DEFAULT_INTERFACE_NODE_COLOR,
  chatbot: DEFAULT_CHATBOT_NODE_COLOR,
  zap: DEFAULT_ZAP_NODE_COLOR,
} as const;

type AssetTypeColorMap = typeof DEFAULT_COLORS_BY_ASSET_TYPE;

export function getDefaultColorForAssetType(
  assetType: AssetType | undefined,
): string {
  if (!assetType) {
    return DEFAULT_NODE_COLOR;
  }
  return (
    DEFAULT_COLORS_BY_ASSET_TYPE[assetType as keyof AssetTypeColorMap] ??
    DEFAULT_NODE_COLOR
  );
}
